import { EventBus } from '@/app'

export default {
    data() {
        return {
            model: null,
            index: {},
            all: [],
            initialStatuses: [],
            config: {},
            placements: {},
            paginate: 50,
            page: 1,

            loadingIndex: false,
            loadingAll: false,
            loadingModel: false,
            loadingInitialStatuses: false,
            loadingConfig: false,

            dataTable: {
                headerTopComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ],
                headerBottomComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ]
            },
            
            //  definir
            table: 'define_table',
            name: 'define_name',
            class: 'define_class'
        }
    },

    methods: {
        prepareResource(resource) {
            //
        },

        prepareResources(resources) {
            resources.map(r => this.prepareResource(r))
        },

        loadIndex(payload = {}) {
            this.$set(this, 'loadingIndex', true)

            let params = {}

            if(payload.scopes) {
                params.scopes = payload.scopes
            }

            if(payload.appends) {
                params.appends = payload.appends
            }

            params.page = payload.page
                ? payload.page
                : this.page

            params.paginate = payload.paginate
                ? payload.paginate
                : this.paginate

            return axios({
                method: 'get',
                url: route(`api.${_.camelCase(this.table)}.index`),
                params: params
            })
            .then(response => {
                if(response.data.success) {
                    this.prepareResources(response.data.data.data)

                    if(payload.placement) {
                        this.$set(this.placements, payload.placement, response.data.data)
                    } else {
                        this.$set(this, 'index', response.data.data)
                    }

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingIndex', false))
        },

        loadAll(payload = {}) {
            this.$set(this, 'loadingAll', true)

            let params = {}

            if(payload.scopes) {
                params.scopes = payload.scopes
            }

            if(payload.appends) {
                params.appends = payload.appends
            }

            if(payload.from_cache) {
                params.from_cache = true
            }

            return axios({
                method: 'get',
                url: route('api.models.table.all', this.table),
                params: params
            })
            .then(response => {
                if(response.data.success) {
                    this.prepareResources(response.data.data)

                    if(payload.placement) {
                        this.$set(this.placements, payload.placement, response.data.data)
                    } else {
                        this.$set(this, 'all', response.data.data)
                    }

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingAll', false))
        },

        loadIndexBySearch(query, payload = {}) {
            return this.loadIndex(this.$Util.mergeRecursive(payload, {
                scopes: {
                    searchScope: query
                }
            }))
        },

        loadAllBySearch(query, payload = {}) {
            return this.loadAll(this.$Util.mergeRecursive(payload, {
                scopes: {
                    searchScope: query
                }
            }))
        },

        loadAIndexBySearchId(id, payload = {}) {
            return this.loadIndex(this.$Util.mergeRecursive(payload, {
                scopes: {
                    searchIdScope: id
                }
            }))
        },

        loadAllBySearchId(id, payload = {}) {
            return this.loadAll(this.$Util.mergeRecursive(payload, {
                scopes: {
                    searchIdScope: id
                }
            }))
        },

        loadInitialStatuses() {
            this.$set(this, 'loadingInitialStatuses', true)

            return axios({
                method: 'get',
                url: route('api.models.table.initialStatuses', this.table),
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'initialStatuses', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingInitialStatuses', false))
        },

        loadConfig() {
            this.$set(this, 'loadingConfig', true)

            return axios({
                method: 'get',
                url: route('api.models.table.config', this.table),
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'config', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingConfig', false))
        },

        loadModel(resource, payload = {}) {
            this.$set(this, 'loadingModel', true)

            let params = {}

            if(payload.scopes) {
                params.scopes = payload.scopes
            }

            if(payload.appends) {
                params.appends = payload.appends
            }

            return axios({
                method: 'get',
                url: route(`api.${this.table}.show`, resource),
                params: params
            })
            .then(response => {
                if(response.data.success) {
                    if(payload.placement) {
                        this.$set(this.placements, payload.placement, response.data.data)
                    } else {
                        this.$set(this, 'model', response.data.data)
                    }

                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
            .finally(() => this.$set(this, 'loadingModel', false))
        },

        status(resource, status) {
            return axios({
                method: 'post',
                url: route(`api.${this.table}.status`, resource),
                data: {status: status}
            })
            .then(response => {
                if(response.data.success) {
                    this.$alert('Actualización exitosa', 'Listo!', 'success')

                    EventBus.$emit('root', `${this.table}.statused`, response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data,message, 'Error!', 'error')

                    return Promise.reject(response.data,message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')

                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        }
    },

    created() {
        this.$models.addModel(this)
    }
}